import type { FaireProductEntity } from "../../entity_types/product";

export const p_x2bzfgykxv: FaireProductEntity = {
  token: "p_x2bzfgykxv",
  type: "product",
  name: "IT2594E-MAHJONG | Mahjong Embroidery Sweatshirt",
  brandToken: "b_4o95d3k7hq",
  brandName: "BUCKETLIST INC",
  imageUrl:
    "https://cdn.faire.com/fastly/81d10e58379697f6404159d4edf54adffbdb9362d6ea5de4033af63ca1e0d352.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8351a1de76f7ec5917a802aafbab8588f8e370402b90bc29f3c2d3f4ccfd98a5.jpeg",
    "https://cdn.faire.com/fastly/4af8b2c560f7c97df96726c97e8682c7c9039230cd3e36df30fb28372b8b7351.jpeg",
    "https://cdn.faire.com/fastly/27ae39db9b826594502e267d5bf2722002f8105e164164a2d16d0828c7c0a63b.jpeg",
    "https://cdn.faire.com/fastly/20447971f961f71e059b4c916727b92c7406cf5d939b91cab21eb0e088a61869.jpeg",
    "https://cdn.faire.com/fastly/d4da5950a17fbc5c1076c5ab3fc75b0a9148a09297c45b96faf883e0ea9bbbd4.jpeg",
    "https://cdn.faire.com/fastly/f9df39560bca3530bee3fa13de4e983ebf3b102ecbc9f8e034262d745b2d8503.jpeg",
    "https://cdn.faire.com/fastly/1448fb9740ac9b2e3ad8a78751eac3c6ecd5992a2b72800c28a3b715597427cb.jpeg",
    "https://cdn.faire.com/fastly/e91baf7c3c6d02c407aa4f06a7410bc37da5181f031ce1641b68e3d880d7b1be.jpeg",
    "https://cdn.faire.com/fastly/4381b60dfd9519d919ac6ac723239ab63d9545ab07080e3f270314cfb06874b2.jpeg",
    "https://cdn.faire.com/fastly/caf791927ceadcc7f3a0a804e9b8e10c9f3b6548c210bf0bd8fea106d866d8eb.jpeg",
    "https://cdn.faire.com/fastly/92cca247591b05a6b2daf010999a9dbf43d463e21988ad78bd3f5e35cf4a88de.png",
    "https://cdn.faire.com/fastly/8e225b664f44baa45cfd82c8bfab96e4df1fc5c559edff4c999522d2ef7da894.jpeg",
    "https://cdn.faire.com/fastly/7389cc0cf95872c42ac911cf9f1fb7e48051665720384a7026d7afa5d5eb06c9.jpeg",
    "https://cdn.faire.com/fastly/13a01b1087125779222bf9a296a231d3209cd4109b8ca06d4f9600a460052dbf.jpeg",
    "https://cdn.faire.com/fastly/e81957824e8ccdda22c8d4899830444f0a3059ffbe0d6e133f40ecea50209b6d.jpeg",
    "https://cdn.faire.com/fastly/b5a2832af5fbf0fc631001ed3760857b045dc70728b390d39b2f9d517da10040.jpeg",
    "https://cdn.faire.com/fastly/fbabb5a9b489410a405f03b04db7e06f49840f4e75d01b6d2011d16253b8ddf9.jpeg",
    "https://cdn.faire.com/fastly/a980c22faf861df28ca51b50e5ed4305f0e0ef2d28265f5f75106c2a44a80a72.jpeg",
    "https://cdn.faire.com/fastly/46081038af5efaa8ebd3f21135ddfdb349d8b89b53f0b471e971997ddb7d1749.jpeg",
    "https://cdn.faire.com/fastly/c8bd5d290d7473802cfc5c6aa57ae8f89ecdbcf25ba6a94f68b30dfc67f6843b.jpeg",
    "https://cdn.faire.com/fastly/65bd9bf10cc3ce6dcdfa05af9e6c949968c19f22c635ea0a31242ec1ea2c7bb0.jpeg",
  ],
  priceDollars: 29.95,
  description:
    "Mahjong Embroidery Sweatshirt\n- High-quality embroidered 'MAHJONG' text in soft pink thread for a tactile and premium finish.\n- Premium mid-weight grey fleece fabric ensures a cozy feel and shape retention.\n- Relaxed, slightly oversized fit with dropped shoulders for a modern silhouette.\n- Ribbed crewneck, cuffs, and hem with detailed stitching for durable construction.\n- This top serves as a refined foundation when paired with the matching pink shorts (IP5839).\n- Versatile grey tone that pairs effortlessly with denim, joggers, or casual bottoms.\n\nCombining effortless comfort with playful sophistication, this sweatshirt features high-quality pink embroidered 'MAHJONG' text across the chest. Designed with a modern, relaxed fit and crafted from soft mid-weight fleece, it offers a stylish and tactile addition to any casual wardrobe.",
  tags: [],
  msrpDollars: 59.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:38.780Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
